import React from 'react';
import { m } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { methodSteps } from '../../data/method';
export function Method() {
  return <section className="bg-bg-secondary py-14 sm:py-16" data-id="element-149" data-mp="2ao7lnam48r2j">
      <div className="mx-auto max-w-3xl px-6 text-center sm:px-8" data-id="element-150" data-mp="26nnlrza5r9cp">
        <SectionTag icon="🎯" data-id="element-151" data-mp="26nfaucxlie45">El método "Sesión en Mano"</SectionTag>
        <h2 className="mt-5 font-heading text-[28px] font-bold uppercase text-marino sm:text-[36px]" data-id="element-152" data-mp="21pm1jb0zx3zn">
          El Método "Sesión en Mano"
        </h2>
        <p className="mt-4 text-base leading-relaxed text-gris-texto sm:text-lg" data-id="element-153" data-mp="1wru9mh0cphvg">
          Preparar tu próximo entrenamiento puede ser así de sencillo:
        </p>
      </div>

      <div className="mx-auto mt-10 flex max-w-4xl flex-col gap-4 px-6 sm:flex-row sm:items-stretch sm:gap-3 sm:px-8" data-id="element-154" data-mp="1nqme26p7yv52">
        {methodSteps.map((step, i) => <React.Fragment key={step.n} data-id="element-155" data-mp="3i3vsmcwmh6u6" data-mpi={i}>
            <m.div initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="flex flex-1 flex-col items-center rounded-2xl border border-gris-claro bg-white p-6 text-center shadow-leve" data-id="element-156" data-mp="3i0q1yt8chwwc">
              <div className={`flex h-12 w-12 items-center justify-center rounded-full ${step.bgClass}`} data-id="element-157" data-mp="32klsfpcu3wnb">
                <step.icon size={22} className={step.iconClass} data-id="element-158" data-mp="3qag07siaqv0p" />
              </div>
              <p className="mt-3 font-heading text-lg font-bold uppercase tracking-wide text-marino" data-id="element-159" data-mp="3v76f4cid7kkj">
                {step.n}. {step.title}
              </p>
              <p className="mt-1.5 text-sm leading-relaxed text-gris-texto" data-id="element-160" data-mp="3lietsn7t7yil">{step.text}</p>
            </m.div>
            {i < methodSteps.length - 1 && <ArrowRightIcon size={20} className="mx-auto hidden flex-shrink-0 self-center text-naranja sm:block" aria-hidden="true" data-id="element-161" data-mp="d11v2c89i1x4" />}
          </React.Fragment>)}
      </div>

      <p className="mx-auto mt-8 max-w-2xl px-6 text-center text-sm italic leading-relaxed text-gris-texto sm:px-8 sm:text-base" data-id="element-162" data-mp="nn6w9767f5fs">
        Sin pasarte horas buscando en YouTube. Sin juntar ejercicios aleatorios que no tienen hilo
        conductor. Sin llegar a la pista preguntándote qué vas a hacer cuando los jugadores ya están en
        círculo mirándote.
      </p>
    </section>;
}